class MiniStripe {
  constructor() {

    if(document.querySelector('.mini-stripe') != null && document.querySelector('.mini-stripe') != undefined) {
      this.setEvents();
    }
  }

  setEvents() {

    var btn = document.querySelector(".mini-stripe");
    var modal = document.querySelector(".talk-to-us");
    var overlay = document.querySelector(".talk-to-us__overlay");

    btn.onclick = function(event) {

      event.preventDefault();

      if(modal.classList.contains("talk-to-us--opened")) {
        modal.classList.remove("talk-to-us--opened");
      } else {
        modal.classList.add("talk-to-us--opened");
      }
      
    };

    overlay.addEventListener('click', function(e) {
      e.preventDefault;
      modal.classList.remove("talk-to-us--opened");
    });

      
  }

}

$(document).ready(function() {
  const miniStripe = new MiniStripe();
});
